
import {
    Card,
    CardBody,
    CardFooter,
    Typography,
    Button,
  } from "@material-tailwind/react";

const UserPermistionPage = () => {

    const profilePageRedirect = () =>{
        window.location.href = process.env.REACT_APP_IAAMREG_HOST
    }

    return (
        <div className="flex justify-center h-screen w-screen bg-[conic-gradient(at_bottom_left,_var(--tw-gradient-stops))] from-red-200 to-red-900">
            <Card className="lg:w-2/6 lg:mt-14 mt-6 w-96">
                <CardBody>
                <img className="h-12 w-12 mb-6" alt="candice" src="/img/LogoReport.png" />
                    <Typography variant="h5" color="blue-gray" className="mb-2 font-primary">
                        ท่านไม่ได้รับอนุญาตให้เข้าใช้งาน
                    </Typography>
                    <Typography className="font-primary font-normal">
                        บัญชีของท่านยังไม่ได้รับอนุญาตให้เข้าใช้งานแอปพลิเคชัน<span className="text-red-900">ทันระบาดรายงาน</span> 
                    </Typography>
                </CardBody>
                <CardFooter className="pt-0">
                    <Button className="font-primary" onClick={()=> profilePageRedirect()}>รายละเอียด</Button>
                </CardFooter>
            </Card>
        </div>
    )
}

export default UserPermistionPage;